export default {"src":"/_next/static/media/ico_discount.65a557e2.svg","height":32,"width":32};